// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { secret } from "./secret";


// Initialize Firebase
const app = initializeApp(secret);
export const db = getFirestore(app);